export default __webpack_public_path__ + "static/media/icon_plus.fd0e2f07.svg";